import RequireAuthentication from '@/router/guards/RequireAuthentication'
import { lazy } from 'react'
import DiscountPharmacies from './pages/DiscountPharmacies'

const MyBenefits = lazy(() => import('./pages/MyBenefits'))
const BeepHealth = lazy(() => import('./pages/BeepHealth'))
const PartnerLaboratories = lazy(() => import('./pages/PartnerLaboratories'))

const MyBenefitsRoutes = [
  <RequireAuthentication
    path="/meus-beneficios"
    key="/beneficios"
    exact
    component={MyBenefits}
  />,
  <RequireAuthentication
    path="/meus-beneficios/beep-saude"
    key="/meus-beneficios/beep-saude"
    exact
    component={BeepHealth}
  />,
  <RequireAuthentication
    path="/meus-beneficios/laboratorios-parceiros"
    key="/meus-beneficios/laboratorios-parceiros"
    exact
    component={PartnerLaboratories}
  />,
  <RequireAuthentication
    path="/meus-beneficios/farmacias-desconto"
    key="/meus-beneficios/farmacias-desconto"
    exact
    component={DiscountPharmacies}
  />,
]

export default MyBenefitsRoutes
